export const vatPercentage = 0.075;
